import React, { useEffect, useState } from "react";
import { Alert, Badge, Button, Col, Container, Form, Modal, Row, Spinner, Table } from "react-bootstrap";
import { authFetch } from "../utils/authFetch";
import TarifeManopera from "../comenzi/TarifeManopera";

const emptyOperation = () => ({ cod: "", denumire: "", skill: 1, minute: "" });

export default function CoduriManoperaProd() {
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(0);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const [revision, setRevision] = useState(0);
  const [editor, setEditor] = useState(null);
  const [saveError, setSaveError] = useState("");
  const [saving, setSaving] = useState(false);
  const limit = 25;

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError("");
    const timer = setTimeout(async () => {
      try {
        const params = new URLSearchParams({ search: query.trim(), skip: String(page * limit), limit: String(limit) });
        const data = await authFetch(`/comenzi-prod/manopere-lk/?${params}`);
        if (active) { setItems(data.items || []); setTotal(data.total || 0); }
      } catch (err) {
        if (active) { setError(err.message || "Nu s-au putut încărca operațiile."); setItems([]); }
      } finally {
        if (active) setLoading(false);
      }
    }, 250);
    return () => { active = false; clearTimeout(timer); };
  }, [query, page, revision]);

  const openEditor = item => {
    setSaveError("");
    setNotice("");
    setEditor(item ? { ...item, skill: item.skill ?? "", minute: item.minute ?? "" } : emptyOperation());
  };
  const field = (key, value) => setEditor(prev => ({ ...prev, [key]: value }));
  const save = async event => {
    event.preventDefault();
    if (saving) return;
    const minutes = editor.minute === "" ? null : Number(editor.minute);
    if (!editor.cod.trim() || !editor.denumire.trim() || (minutes !== null && (!Number.isFinite(minutes) || minutes <= 0))) {
      setSaveError("Completează codul și denumirea. Timpul, dacă este completat, trebuie să fie mai mare decât zero.");
      return;
    }
    setSaving(true);
    setSaveError("");
    try {
      await authFetch(editor.id ? `/comenzi-prod/manopere-lk/${editor.id}` : `/comenzi-prod/manopere-lk/`, {
        method: editor.id ? "PUT" : "POST",
        body: JSON.stringify({ cod: editor.cod.trim(), denumire: editor.denumire.trim(), skill: editor.skill === "" ? null : Number(editor.skill), minute: minutes }),
      });
      setEditor(null);
      setNotice("Operația de manoperă a fost salvată.");
      setRevision(value => value + 1);
    } catch (err) {
      setSaveError(err.message || "Operația nu a putut fi salvată.");
    } finally { setSaving(false); }
  };

  return <Container className="py-4">
    <div className="d-flex justify-content-between align-items-center gap-3 mb-2">
      <h3 className="mb-0">Coduri manoperă</h3>
      <Button onClick={() => openEditor(null)}>+ Adaugă operație</Button>
    </div>
    <p className="text-muted">Definește operațiile de service și timpul normat. 1,3 ore = 78 minute.</p>
    <TarifeManopera />
    {notice && <Alert variant="success" dismissible onClose={() => setNotice("")}>{notice}</Alert>}
    {error && <Alert variant="danger">{error}</Alert>}
    <Form.Control aria-label="Caută operație" placeholder="Caută după cod sau denumire…" value={query}
      onChange={event => { setQuery(event.target.value); setPage(0); }} className="mb-3" />
    <Table bordered hover responsive className="align-middle">
      <thead className="table-light"><tr><th>Cod</th><th>Denumire manoperă</th><th>Skill</th><th>Timp normat (ore / minute)</th><th /></tr></thead>
      <tbody>
        {loading ? <tr><td colSpan={5}><Spinner size="sm" /> Se încarcă…</td></tr> : items.map(item =>
          <tr key={item.id}>
            <td className="fw-semibold">{item.cod}</td><td>{item.denumire}</td>
            <td>{item.skill ? <Badge bg="secondary">{item.skill === 1 ? "Ușoară" : "Complicată"}</Badge> : "—"}</td>
            <td>{item.minute == null ? "Necompletat" : `${Number((Number(item.minute) / 60).toFixed(5))} ore / ${Number(item.minute)} min`}</td>
            <td className="text-end"><Button variant="outline-primary" size="sm" onClick={() => openEditor(item)}>Editează</Button></td>
          </tr>)}
        {!loading && !items.length && <tr><td colSpan={5} className="text-muted text-center py-4">Nu există operații pentru această căutare.</td></tr>}
      </tbody>
    </Table>
    <div className="d-flex justify-content-between align-items-center">
      <span className="text-muted">{total} operații</span>
      <div className="d-flex gap-2"><Button variant="outline-secondary" disabled={loading || page === 0} onClick={() => setPage(value => value - 1)}>Înapoi</Button>
        <Button variant="outline-secondary" disabled={loading || (page + 1) * limit >= total} onClick={() => setPage(value => value + 1)}>Înainte</Button></div>
    </div>
    <Modal show={editor !== null} onHide={() => !saving && setEditor(null)} centered backdrop={saving ? "static" : true} keyboard={!saving}>
      <Modal.Header closeButton={!saving}><Modal.Title>{editor?.id ? "Editează operația" : "Adaugă operație de manoperă"}</Modal.Title></Modal.Header>
      {editor && <Form onSubmit={save}>
        <Modal.Body>
          {saveError && <Alert variant="danger">{saveError}</Alert>}
          <fieldset disabled={saving}>
            <Form.Group controlId="manopera-cod" className="mb-3"><Form.Label>Cod</Form.Label>
              <Form.Control autoFocus required maxLength={50} value={editor.cod} onChange={e => field("cod", e.target.value)} /></Form.Group>
            <Form.Group controlId="manopera-denumire" className="mb-3"><Form.Label>Denumire manoperă</Form.Label>
              <Form.Control required maxLength={200} value={editor.denumire} onChange={e => field("denumire", e.target.value)} /></Form.Group>
            <Row><Col><Form.Group controlId="manopera-skill"><Form.Label>Skill</Form.Label>
              <Form.Select value={editor.skill} onChange={e => field("skill", e.target.value)}>
                <option value="">Nespecificat</option><option value={1}>1 — Ușoară</option><option value={2}>2 — Complicată</option>
              </Form.Select></Form.Group></Col>
              <Col><Form.Group controlId="manopera-minute"><Form.Label>Minute normate</Form.Label>
                <Form.Control type="number" min={0.001} step={0.001} value={editor.minute} onChange={e => field("minute", e.target.value)} />
                <Form.Text>Minute, inclusiv zecimale: 0,5 înseamnă jumătate de minut. Lasă gol dacă timpul nu este stabilit.</Form.Text>
              </Form.Group></Col></Row>
          </fieldset>
        </Modal.Body>
        <Modal.Footer><Button variant="secondary" disabled={saving} onClick={() => setEditor(null)}>Renunță</Button>
          <Button type="submit" disabled={saving}>{saving ? "Se salvează…" : "Salvează"}</Button></Modal.Footer>
      </Form>}
    </Modal>
  </Container>;
}
